export const FETCH_TIMEOUT = {
	SSR: 4000,
	CLIENT: 4000,
	DS: 30000,
}

export const FETCH_RETRIES = {
	SSR: 0,
	CLIENT: 0,
	DS: 1,
}
